<template lang="pug">
transition(name="modal")
  .modal-mask
    .modal-wrapper.modal.mt-5(@click.self="$modal.close()")
      .modal-dialog.modal-lg(role="document")
        .modal-content.p-2
          .modal-header
            h4.modal-title {{ restaurant.name_en }}
            button.close(type="button" @click="$modal.close()")
              span(aria-hidden="true") &times;
          .modal-body
            label.font-weight-bold Description
            p {{ restaurant.description_en }}
            label.font-weight-bold Address
            p {{ restaurant.location.formatted_address }}
            label.font-weight-bold Phone
            p {{ restaurant.phone }}
            label.font-weight-bold Halal Info
            p(v-if="restaurant.halal_certificates") {{ restaurant.halal_certificates }}
            p(v-else) Halal Certified
</template>

<script>
export default {
  props: ['restaurant']
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/RestaurantInfoModal.vue